var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-table',{ref:"recordTable",attrs:{"columns":_vm.columns,"data":_vm.loadData,"customRow":_vm.customRow,"rowKey":record => record.id,"pagination":{ showTotal: (total) => `共 ${total} 条` }}})
}
var staticRenderFns = []

export { render, staticRenderFns }